import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import LogoComponent from '@ui/components/Logo/Logo.component';
import LangSelectorContainer from '../Lang-selector/Lang-selector.container';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({ lang }: IProps) => {
    return (
        <>
            <AppBar className="header__wrap_auth" position="relative">
                <Toolbar className="header_auth" variant="dense">
                    {/* <LogoComponent variant="header" lang={lang} /> */}
                        {/* <Box
                        className="header__logo"
                        component="img"
                        src={`public/img/svg/${
                            lang === 'en' ? 'en_' : ''
                        }logo.svg`}
                        width={240}
                        height={140}
                    /> */}
                    <Box className="header__menu-list">
                        <Box className="header__menu-wrap">
                            <LangSelectorContainer />
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>
        </>
    );
};

const HeaderAuthComponent = React.memo(Component);

export default HeaderAuthComponent;
